var GuardState;

(function (GuardState) {
  GuardState[GuardState["UNKNOWN"] = 0] = "UNKNOWN";
  GuardState[GuardState["NO_LOGIN"] = 1] = "NO_LOGIN";
  GuardState[GuardState["REJECTED"] = 2] = "REJECTED";
  GuardState[GuardState["ALLOWED"] = 3] = "ALLOWED";
})(GuardState || (GuardState = {}));

export default GuardState;